<template>
  <div class="sidebar-con">
    <div class="icon-con" v-if="sidebar.opened">
      <el-image
        style="width: 128px; height: 128px;"
        :src="url"
        fit="fit"/>
    </div>
    <div class="scroll-con">
      <scroll-bar>
        <el-menu style="text-align: left;"
                 mode="vertical"
                 :show-timeout="200"
                 :default-active="$route.path"
                 :collapse="isCollapse"
                 text-color="#6b8199"
                 active-text-color="#0c6fb3"
        >
          <sidebar-item :routes="routes"></sidebar-item>
        </el-menu>
      </scroll-bar>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import SidebarItem from './SidebarItem'
  import ScrollBar from '@/components/ScrollBar'

  export default {
    data() {
      return {
        url: 'https://oss.mssbaby.com/icon/logo.jpg',
      }
    },
    components: { SidebarItem, ScrollBar },
    computed: {
      ...mapGetters([
        'sidebar',
        'routers'
      ]),
      routes() {
        // return this.$router.options.routes
        return this.routers
      },
      isCollapse() {
        return !this.sidebar.opened
      }
    }
  }
</script>
<style scoped>
  .sidebar-con{
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: start;
    background: #FFFFFF;
  }
  .icon-con{
    width: 100%;
    height: 180px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #FFFFFF;
    border-bottom: 1px #707070 dotted;
  }
  .scroll-con{
    width: 100%;
    height: 70%;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    justify-content: start;
  }
</style>



// WEBPACK FOOTER //
// src/views/layout/components/Sidebar/index.vue